export enum Plans {
  Expert = 'expert',
  ExpertPlus = 'expertplus',
  Pro = 'pro',
  ProPlus = 'proplus',
  Starter = 'starter',
  StarterPlus = 'starterplus',
  Agency = 'agency',
  Designer = 'designer',
  LocalSEO = 'localseo',
  Free = 'free',
  DIY = 'diy',
  ReSeller = 'reseller'
}